<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="switchCoupon({ couponName: $t('common.all'), couponId: '' })"
              :class="{ 'selected': useLogInfo.conditions.couponId === '' }">
              {{ $t('common.all') }}
            </li>
            <li v-for="(item, index) in useLogInfo.coupons" :key="index"
              @click="switchCoupon(item)"
              :class="{ 'selected': useLogInfo.conditions.couponId == item.couponId }">
              {{ item.couponName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('couponManage.queryCondition') }}</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input v-model="useLogInfo.conditions.userName"
                :placeholder="$t('couponManage.userName')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-input v-model="useLogInfo.conditions.tel"
                :placeholder="$t('couponManage.phoneNumber')" clearable style="width:200px" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryUseLogMethod()">
                <i class="el-icon-search"></i> {{ $t('couponManage.query') }}
              </el-button>
              <el-button @click="_resetUseLogMethod()">
                <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('couponManage.useLogs') }}</span>
          </div>
          <el-table :data="useLogInfo.useLogs" border style="width:100%" v-loading="loading">
            <el-table-column prop="useId" :label="$t('couponManage.id')" align="center" />
            <el-table-column prop="couponName" :label="$t('couponManage.couponName')" align="center" />
            <el-table-column prop="userName" :label="$t('couponManage.userName')" align="center" />
            <el-table-column prop="tel" :label="$t('couponManage.phoneNumber')" align="center" />
            <el-table-column prop="orderId" :label="$t('couponManage.orderId')" align="center" />
            <el-table-column prop="useTime" :label="$t('couponManage.useTime')" align="center" />
            <el-table-column :label="$t('couponManage.discountAmount')" align="center">
              <template slot-scope="scope">
                ￥{{ scope.row.discountAmount }}
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="useLogInfo.conditions.page"
            :page-size="useLogInfo.conditions.row" layout="total, prev, pager, next"
            :total="useLogInfo.total" style="margin-top: 20px; text-align: right;">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listCouponUseLog, listShopCoupon } from '@/api/coupon/couponApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'CouponUseLogManage',
  data() {
    return {
      loading: false,
      useLogInfo: {
        useLogs: [],
        coupons: [],
        total: 0,
        conditions: {
          userName: '',
          tel: '',
          couponId: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.useLogInfo.conditions.shopId = getShopId()
    this._listCoupons()
    this._listUseLogs()
  },
  methods: {
    async _listCoupons() {
      try {
        const res = await listShopCoupon({
          shopId: getShopId(),
          page: 1,
          row: 100
        })
        this.useLogInfo.coupons = res.data || []
      } catch (error) {
        console.error('获取优惠券列表失败:', error)
      }
    },
    async _listUseLogs() {
      this.loading = true
      try {
        const res = await listCouponUseLog(this.useLogInfo.conditions)
        this.useLogInfo.useLogs = res.data
        this.useLogInfo.total = res.total
      } catch (error) {
        console.error('获取使用记录失败:', error)
      } finally {
        this.loading = false
      }
    },
    _queryUseLogMethod() {
      this.useLogInfo.conditions.page = 1
      this._listUseLogs()
    },
    _resetUseLogMethod() {
      this.useLogInfo.conditions.userName = ''
      this.useLogInfo.conditions.tel = ''
      this.useLogInfo.conditions.page = 1
      this._listUseLogs()
    },
    handleCurrentChange(val) {
      this.useLogInfo.conditions.page = val
      this._listUseLogs()
    },
    switchCoupon(coupon) {
      this.useLogInfo.conditions.couponId = coupon.couponId || ''
      this.useLogInfo.conditions.page = 1
      this._listUseLogs()
    }
  }
}
</script>

<style scoped>
/* 使用 el-card 和全局 list-selector 样式，无需自定义样式 */
</style>

